import { ROSTER_LIST, type RosterRow } from '@/pages/home/data';

const toneClass: Record<RosterRow['statusTone'], { chip: string; dot: string }> = {
  primary: { chip: 'bg-primary-100 text-primary-700', dot: 'bg-primary-500' },
  accent: { chip: 'bg-accent-100 text-accent-800', dot: 'bg-accent-500' },
  secondary: { chip: 'bg-secondary-200 text-foreground-700', dot: 'bg-secondary-500' },
};

export default function Roster() {
  return (
    <section
      id="roster"
      className="scroll-mt-24 bg-background-100/70 py-16 md:py-24"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        {/* header */}
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
              <span className="inline-block h-px w-8 bg-primary-500" />
              02 · 主播名单
            </div>
            <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              主播塌房名单 · 一人一档
            </h2>
            <p className="mt-2 max-w-lg text-sm text-foreground-600">
              每张脸都配一份档案：从翻车现场到后续回应，名单进度一一对应，吃瓜不迷路。
            </p>
          </div>
          <div className="flex flex-wrap gap-2 text-xs">
            {[
              ['bg-primary-500', '已塌房'],
              ['bg-accent-500', '深扒中'],
              ['bg-secondary-400', '已辟谣'],
            ].map(([c, t]) => (
              <span
                key={t}
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-foreground-600 ring-1 ring-background-200"
              >
                <span className={`h-2 w-2 rounded-full ${c}`} />
                {t}
              </span>
            ))}
          </div>
        </div>

        {/* list */}
        <div className="mt-10 grid gap-4 md:grid-cols-2">
          {ROSTER_LIST.map((row) => {
            const tone = toneClass[row.statusTone];
            return (
              <a
                key={row.index}
                href="#bundle"
                className="group flex items-center gap-5 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-all hover:border-primary-300 hover:bg-background-50 sm:p-4"
              >
                {/* cover */}
                <div className="relative h-28 w-24 shrink-0 overflow-hidden rounded-md sm:h-36 sm:w-28">
                  <img
                    src={row.cover}
                    alt={`抖阴主播${row.name} 塌房名单`}
                    title={`抖阴黑料 · ${row.name} 翻车档案`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-1.5 top-1.5 flex h-6 w-6 items-center justify-center rounded-sm bg-background-950/70 font-heading text-[11px] font-bold text-background-50 backdrop-blur">
                    {row.index}
                  </span>
                </div>

                {/* content */}
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="truncate text-base font-bold text-foreground-950 group-hover:text-primary-700 sm:text-lg">
                      {row.name}
                    </h3>
                    <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${tone.chip}`}>
                      <span className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} />
                      {row.status}
                    </span>
                  </div>
                  <div className="mt-1 text-xs text-foreground-500">分区 · {row.area}</div>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {row.summary}
                  </p>
                </div>

                <i className="ri-arrow-right-s-line hidden text-xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500 sm:block" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}